import * as React from 'react';
import { observable } from 'mobx';
import { observer } from 'mobx-react';
import autobind from 'autobind-decorator';

import { DataTableView, Column } from 'src/core/ui/data-table.view';
import { OptionsDialogView } from 'src/core/ui/options-dialog.view';
import { TextView } from 'src/core/ui/text.view';
import { ProductCategoryEditorController } from 'src/app/products/product-categories/parts/product-category-editor.controller';
import { BooleanView } from 'src/core/ui/boolean.view';
import { Modal, Button, Badge, Timeline } from 'antd';
import { RuleOperationsService, IStackTraceMessage } from 'src/app/rules/rules/rule-services';
import { resolve } from 'inversify-react';
import { FormatService } from "src/core/services/format.service";
import { RuleStackTraceList } from 'src/app/rules/rules/stacktrace/rule-stacktrace-list.view';
import { ControllerProps } from 'src/router';
import { RulesDataService } from 'src/app/rules/rules/form/rules-form.data';
import { ConfigurationService } from 'src/core/services/configuration.service';
import { ObjectUtils } from 'src/core/utils/object';
import { ToastNotifications } from 'src/core/ui/toast';

interface RuleStackTraceListControllerProps {
	id: string;
}

interface IState {
	groupds: { [sessionId: string]: IStackTraceMessage[] };
	rule?: RuleItem;
	pageIndex: number;
	pageSize: number;
	total: number;
}

@observer
export class RuleStackTraceListController extends React.Component<ControllerProps<RuleStackTraceListControllerProps>, IState> {
	constructor(props: any) {
		super(props);

		this.state = {
			groupds: {},
			pageIndex: 0,
			pageSize: 100,
			total: 0
		}
	}


	@resolve
	rulesService: RuleOperationsService

	@observable
	protected dataService: RulesDataService;

	@resolve
	formatService: FormatService;
	
	@resolve
	protected toast: ToastNotifications;

	@resolve
	protected configurationService: ConfigurationService;

	@observable
	defaultLanguaje: string;

	@autobind
	protected async loadStackTrace(ruleId: number, pageIndex: number, pageSize: number) {
		this.props.setBusy(true);

		var raw = await this.rulesService.getStackTrace(ruleId, pageSize, pageIndex);

		this.setState({ total: raw.total, pageIndex: raw.pageIndex, pageSize: raw.pageSize });

		var messages = raw.items.map((item, index) => {
			return JSON.parse(item) as IStackTraceMessage;
		});

		this.groupBySession(messages);

		this.props.setBusy(false);
	}

	private groupBySession(messages: IStackTraceMessage[]) {

		var result = {};
		

		for (var trace of messages) {
			if (trace.sessionId) {
				if (result[trace.sessionId])
					result[trace.sessionId].push(trace);
				else
					result[trace.sessionId] = observable([trace]);
			}
		}

		this.setState({ groupds: {...result} });
	}

	protected request() {
		this.dataService = RulesDataService.make();
		this.configurationService.current()
			.then(res => {
			this.defaultLanguaje = res.defaultLanguage;
				
					// Load entity
			this.dataService.addFilter('id', 'eq', this.props.match.params.id);
			this.dataService.addSorting('id', 'asc', true);
			this.dataService.pageSize = 1;
			this.dataService.load(query => query)
				.catch((error) => {
					this.toast.showToast('Request failed', ObjectUtils.parseError(error), 'error');
				})
				.then(() => {
					this.props.setBusy(false);
					this.setState({ rule: this.dataService.item });
				});
				
			});
	}

	public componentDidMount() {
		this.loadStackTrace(Number.parseInt(this.props.match.params.id), this.state.pageIndex, this.state.pageSize);
		this.request();
	}

	render() {

		return (<div className="window window-normal">

			<div className="panel" style={{ minHeight: '100px' }}>
				<RuleStackTraceList
					total={this.state.total}
					pageIndex={this.state.pageIndex}
					pageSize={this.state.pageSize}
					onPageChange={p => this.loadStackTrace(this.state.rule.id, p, 100)}
					item={this.state.rule}
					items={this.state.groupds} />

				<Button style={{ position: 'fixed', top: '5%', right: '5%' }} onClick={() => this.loadStackTrace(this.state.rule.id, this.state.pageIndex, this.state.pageSize)}>Reload</Button>

				</div>
			</div>
		);
	}
}



// WEBPACK FOOTER //
// ./src/app/rules/rules/stacktrace/rule-stacktrace-list.controller.tsx